import QuickForm from "../QuickForm/QuickForm";

const providerOptions = [
    { value: 'airbnb', text: 'Airbnb' },
    { value: 'vrbo', text: 'VRBO' },
    { value: 'booking.com', text: 'Booking.com' },
]

const entityTypeOptions = [
    { value: 'property', text: 'Property' },
    { value: 'building', text: 'Building' },
]

const syncStatusOptions = [
    { value: 'active', text: 'Active' },
    { value: 'inactive', text: 'Inactive' },
    { value: 'pending', text: 'Pending' },
    { value: 'error', text: 'Error' },
]

export default function IntegrationForm(props: {
    initialData: any,
    onSubmit: (data: any) => Promise<any>,
    disabled?: boolean,
}) {
    const { initialData, onSubmit, disabled } = props

    return (
        <QuickForm
            initialData={initialData}
            disabled={disabled}
            onSubmit={onSubmit}
            fields={[
                {
                    fieldName: 'entityType',
                    fieldLabel: 'Entity Type',
                    fieldType: 'select',
                    placeholder: '- Select Entity Type -',
                    options: entityTypeOptions,
                    required: true,
                    layout: { xs: 12, md: 6 },
                },
                {
                    fieldName: 'entityId',
                    fieldLabel: 'Entity ID',
                    fieldType: 'text',
                    placeholder: 'e.g. 6123abc...',
                    required: true,
                    layout: { xs: 12, md: 6 },
                },
                {
                    fieldName: 'provider',
                    fieldLabel: 'Provider',
                    fieldType: 'select',
                    placeholder: '- Select Provider -',
                    options: providerOptions,
                    required: true,
                    layout: { xs: 12, md: 6 },
                },
                {
                    fieldName: 'primaryExternalId',
                    fieldLabel: 'Primary External ID',
                    fieldType: 'text',
                    placeholder: 'e.g. 123456789',
                    required: true,
                    layout: { xs: 12, md: 6 },
                },
                {
                    fieldName: 'externalIds',
                    fieldLabel: 'External IDs (JSON)',
                    fieldType: 'textarea',
                    placeholder: '{"propertyId": "123", "unitId": "456"}',
                    layout: { xs: 12 },
                },
                {
                    fieldName: 'overrideData',
                    fieldLabel: 'Override Data (JSON)',
                    fieldType: 'textarea',
                    placeholder: '{"title": "Custom title..."}',
                    layout: { xs: 12 },
                },
                {
                    fieldName: 'sync.status',
                    fieldLabel: 'Sync Status',
                    fieldType: 'select',
                    placeholder: '- Select Status -',
                    options: syncStatusOptions,
                    layout: { xs: 12, md: 6 },
                },
            ]}
        />
    )
}
